module.exports = [{
      plugin: require('C:/Users/Chief Keef/personal-website/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-131359385-1"},
    },{
      plugin: require('C:/Users/Chief Keef/personal-website/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
